var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ArrowLeftIcon, Breadcrumbs, BreadcrumbsItem, RowLayout, SidebarItems, styled, } from '@auth0/quantum-product';
import * as React from 'react';
import ApplicationStore from '../../stores/ApplicationStore';
import { useFluxible } from '../hooks/useFluxible';
import { useTranslation } from '../hooks/useTranslation';
import { SidebarItem } from '../Sidebar/SidebarItem';
import { SectionHeader } from './SectionHeader';
import { SidebarSubsection } from './SidebarSubsection';
var StyledSidebarItems = styled(SidebarItems)(function (_a) {
    var theme = _a.theme;
    return ({
        overflowY: 'scroll',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
            width: 0,
            background: 'transparent',
        },
        '& li:first-child > a': {
            paddingTop: 0,
        },
        '& .externalLink': {
            marginLeft: theme.spacing(1),
        },
    });
});
var SectionContainer = styled(RowLayout)(function (_a) {
    var theme = _a.theme, isStickyHeaderVisible = _a.isStickyHeaderVisible;
    return (__assign({ height: '100%', transform: 'translateY(0px)', transition: 'visibility 0s linear 0.2s, transform 0.2s linear' }, (isStickyHeaderVisible && {
        height: "calc(100% - ".concat(theme.layout.headerHeight, "px)"),
        transform: "translateY(".concat(theme.layout.headerHeight, "px)"),
        transitionDelay: '0s',
    })));
});
export var SidebarSection = function (_a) {
    var section = _a.section, maxDepth = _a.maxDepth, openMainMenu = _a.openMainMenu;
    var context = useFluxible();
    var appStore = context.getStore(ApplicationStore);
    var isStickyHeaderVisible = appStore.isStickyHeaderVisible();
    var t = useTranslation().t;
    return (React.createElement(SectionContainer, { sx: { pt: 3, alignContent: 'flex-start' }, gutter: 2, isStickyHeaderVisible: isStickyHeaderVisible },
        React.createElement(RowLayout, { gutter: 5 },
            React.createElement(Breadcrumbs, { "aria-label": "Main Menu" },
                React.createElement(BreadcrumbsItem, { startIcon: React.createElement(ArrowLeftIcon, null), label: t('pages.articlePage.sidebar.mainMenuLabel', 'Main Menu'), variant: "subtitle2", color: "primary", onClick: openMainMenu })),
            React.createElement(SectionHeader, { title: section.title, href: section.url, icon: section.icon })),
        React.createElement(StyledSidebarItems, null, section.children.map(function (item) {
            if (item.type === 'navigationSubsection') {
                return React.createElement(SidebarSubsection, { key: item.title, title: item.title, items: item.children, maxDepth: maxDepth });
            }
            return (React.createElement(SidebarItem, __assign({}, item, { article: item, key: item.url, url: item.url, currentDepth: 0, maxDepth: maxDepth, style: { paddingTop: '16px' } })));
        }))));
};
